module.exports = __webpack_public_path__ + "img/eye.0f59117b.svg";